import { render, staticRenderFns } from "./ModalAddRequisicaoInvoker.vue?vue&type=template&id=7707c5a9"
import script from "./ModalAddRequisicaoInvoker.vue?vue&type=script&lang=ts"
export * from "./ModalAddRequisicaoInvoker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports